/* eslint-disable react/prop-types,no-nested-ternary */
import React, { CSSProperties, Component } from 'react';
import styles from './index.css';
import { hocToolbarItem } from './toolbar-item-hoc';
import { ActionType } from '@editor/src/js/constants/common-action-type';

const Content = item => (
    <React.Fragment>
        <img className={styles.icon} src={item.icon} draggable={false} />
    </React.Fragment>
);
const ItemComponent = hocToolbarItem(Content);

interface ToolbarItemImageProps {
    handleDoubleClick?: () => void;
    handleTouchStart?: (id, value) => void;
    handleMouseDown?: (id, value) => void;
    style?: CSSProperties;
    id?: string;
    defaultValue?: number;
}

export default class ToolbarItemImage extends Component<ToolbarItemImageProps> {
    public constructor(p) {
        super(p);

        this.state = {
            selectedIndex: 0,
        };
    }

    public render() {
        return (
            <ItemComponent
                {...this.props}
                handleTouchStart={this.handleTouchStart}
                handleMouseDown={this.handleMouseDown}
                handleDoubleClick={this.props.handleDoubleClick}
            />
        );
    }

    private handleTouchStart = (id, value) => {
        if (this.props.id === ActionType.FONTSIZE) {
            const { defaultValue = 0 } = this.props;

            if (Object.prototype.toString.call(value) === '[object String]') {
                let fontsize = parseFloat(value.match(/\d+(\.\d+)?/g));
                fontsize += defaultValue;
                fontsize = fontsize < 8 ? 8 : fontsize > 192 ? 192 : fontsize;
                this.props.handleTouchStart?.(id, `font-size-${fontsize}pt`);
            }
        } else {
            this.props.handleTouchStart?.(id, value);
        }
    };

    private handleMouseDown = (id, value) => {
        if (this.props.id === ActionType.FONTSIZE) {
            const { defaultValue = 0 } = this.props;

            if (Object.prototype.toString.call(value) === '[object String]') {
                let fontsize = parseFloat(value.match(/\d+(\.\d+)?/g));
                fontsize += defaultValue;
                fontsize = fontsize < 8 ? 8 : fontsize > 192 ? 192 : fontsize;
                this.props.handleMouseDown?.(id, `font-size-${fontsize}pt`);
            }
        } else {
            this.props.handleMouseDown?.(id, value);
        }
    };
}
